<template>
  <div class="developer-titles__actions">
    <ElButton
      icon="el-icon-edit"
      size="small"
      @click="openEditDeveloperTitleModal"
    >
      {{ $t('DEVELOPER_TITLES.EDIT_DEVELOPER_DETAIL') }}
    </ElButton>
    <ElButton
      icon="el-icon-edit"
      size="small"
      @click="openEditDeveloperSlugModal"
    >
      {{ $t('DEVELOPER_TITLES.EDIT_DEVELOPER_SLUG') }}
    </ElButton>
  </div>
</template>

<script>
import EditDeveloperDetailsModal from './EditDeveloperDetailsModal';
import EditDeveloperSlugModal from './EditDeveloperSlugModal';

export default {
  name: 'DeveloperTitlesActions',
  props: {
    developer: {
      type: Object,
      required: true,
    },
  },

  methods: {
    openEditDeveloperTitleModal() {
      this.$modal
        .open({
          title: this.$t('DEVELOPER_TITLES.EDIT_DEVELOPER_DETAIL'),
          component: EditDeveloperDetailsModal,
          width: '25%',
          props: {
            developer: this.developer,
            refetchDevelopers: this.refetchDevelopers,
          },
          lockScroll: true,
        })
        .then(success => {
          if (success) this.$emit('refetch-developers');
        });
    },
    openEditDeveloperSlugModal() {
      this.$modal
        .open({
          title: this.$t('DEVELOPER_TITLES.EDIT_DEVELOPER_SLUG'),
          component: EditDeveloperSlugModal,
          width: '25%',
          props: {
            developer: this.developer,
            refetchDevelopers: this.refetchDevelopers,
          },
          lockScroll: true,
        })
        .then(success => {
          if (success) this.$emit('refetch-developers');
        });
    },
  },
};
</script>
